import {Logo} from "../../../data/model/shared";
import {cn} from "../../../lib/utils";
import {useColorScheme} from "../../../lib/color-scheme";

export function SimpleLogo (props: { logo: Logo, className?: string, alt?: string }) {
    const { isDark } = useColorScheme();
    let src: string;
    if (typeof props.logo === "string") {
        src = props.logo;
    } else {
        src = isDark ? props.logo.light : props.logo.dark
    }
    return <img src={src} alt={props.alt ?? "logo"} className={cn(props.className)} />;
}